<template>
	<div
		class="radio-indicator"
		:class="{ 'selected': selected }"
	>
		<div class="indicator" v-if="selected">&nbsp;</div>
	</div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';

@Component
export default class RadioIndicator extends Vue {
	@Prop({ default: false, type: Boolean })
	selected: boolean;
}
</script>

<style lang="scss">
.radio-indicator {
	@apply inline-flex flex-row items-center justify-center cursor-pointer rounded-full border bg-fill;

	width: 22px;
	height: 22px;

	transition: background-color 100ms linear;

	border: 1px solid rgba(var(--mainRGB), .15);
	box-shadow: rgba(var(--mainRGB), .05) 0 1px 2px;

	&.selected {
		@apply bg-fill-accent border-accent-primary;
		> .indicator {
			@apply rounded-full select-none;
			background: white;
			width: 12px;
			height: 12px;
		}
	}
}
</style>
